import { SmartTable, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.h2`
  ${typographyV2.titleBase};
  color: var(--text-default);
  margin-bottom: 16px;
`;

export const PastEpisodeDetails = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--border-soft);
  display: inline-flex;
  margin-bottom: 16px;
  align-items: center;
  ${typographyV2.bodyXs};
`;
export const PastEpisodeTickerLabel = styled.span`
  ${typographyV2.bodySm};
`;

export const PastEpisodeText = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const PastEpisodeKey = styled.div`
  width: 16px;
  height: 16px;
  background: var(--surface-primary);
  margin: 0px 8px;
`;

export const ChartImage = styled.img`
  margin-bottom: 32px;
`;

export const NumericalValue = styled.span`
  font-family: var(--font-roboto-mono);
`;

export const Subtext = styled.span`
  color: var(--text-soft);
  ${typographyV2.bodyXs}
`;

export const TableRoot = styled.div`
  ${SmartTable.Styled.TableRow} {
    cursor: default;
  }
`;
